import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { Services } from './components/Services';
import { MassageParty } from './components/MassageParty';
import { Staff } from './components/Staff';
import { Facilities } from './components/Facilities';
import { Bespoke } from './components/Bespoke';
import { Ritual } from './components/Ritual';
import { Reservations } from './components/Reservations';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen text-lavender-50 font-sans selection:bg-lavender-400/40 selection:text-lavender-100" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <About data-id="element-4" />
        <Services data-id="element-5" />
        <MassageParty data-id="element-6" />
        <Staff data-id="element-7" />
        <Facilities data-id="element-8" />
        <Bespoke data-id="element-9" />
        <Ritual data-id="element-10" />
        <Reservations data-id="element-11" />
      </main>
      <Footer data-id="element-12" />
    </div>;
}